import React from 'react'
import { Text, View } from 'styles/reactnative'
import { Space, Tag, Tooltip } from 'antd'
import UserTag from '../../../components/UserTag'
import EntryTime from '../../../components/PositionColumns/EntryTime'
import MemoInput from '../WithdrawalManagement/MemoInput'
import ActionButton from '../ActionButton'
import Price from '../../../components/PositionColumns/Price'
import KrwPrice from '../../../components/PositionColumns/KrwPrice'
import { TagWrap } from '../../../components/AdminUserModal/UserInfoTabs/styles'
import { COLORS } from '../../../constants'
import SleepPoint from '../../../components/PositionColumns/SleepPoint'
import BankInput from '../WithdrawalManagement/BankInput'
import Icon from '@ant-design/icons'
import { IconInfoCircle } from '@tabler/icons'

export const AdminDepositTableColumn: any = (mutate, openModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			align: 'center',
			width: 60,
			render: (text, data) => (
				<Text
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						width: 60,
					}}>
					{text}
				</Text>
			),
		},
		{
			title: '생성일',
			dataIndex: 'created_at',
			align: 'center',
			width: 130,
			render: (text, data) => <EntryTime time={text} />,
		},
		{
			title: '승인일',
			dataIndex: 'confirm_at',
			width: 130,
			align: 'center',
			render: (text, data) => {
				{
					return text ? <EntryTime time={text} /> : <Text>-</Text>
				}
			},
		},
		{
			title: '그룹',
			dataIndex: 'referral_code',
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			width: 150,
			align: 'center',
			render: (text, data) => (
				<UserTag
					userid={data?.user_id}
					email={data?.email}
					nickname={data?.fullname || data?.nickname}
					phone={data?.phone}
					onClick={() => {
						openModal(data?.user_id)
					}}
				/>
			),
		},
		{
			title: '아이디',
			dataIndex: 'loginid',
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '진행',
			dataIndex: 'process',
			width: 50,
			align: 'center',
			render: (text, data) => (
				<TagWrap>
					{text == 1 ? (
						<Tag
							style={{
								backgroundColor: '#f79336',
								color: 'white',
							}}>
							대기
						</Tag>
					) : text == 2 ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							{data?.confirm_amount ? '지급완료' : '입금승인'}
						</Tag>
					) : text == 3 ? (
						<Tag
							style={{ backgroundColor: '#444', color: 'white' }}>
							검토중
						</Tag>
					) : text == 4 ? (
						<Tag style={{ color: 'red' }}>거절됨</Tag>
					) : (
						<Tag>취소</Tag>
					)}
				</TagWrap>
			),
		},
		{
			title: '입금요청',
			dataIndex: 'amount',
			align: 'center',
			render: (text, data) => <KrwPrice price={text || 0} dp={0} />,
		},
		// {
		// 	title: '휴면이벤트',
		// 	dataIndex: 'event_amount',
		// 	align: 'center',
		// 	render: (text, data) => <SleepPoint data={data} />,
		// },
		{
			title: '승인금액',
			dataIndex: 'confirm_amount',
			align: 'center',
			render: (text, data) => <KrwPrice price={text || 0} dp={0} />,
		},
		{
			title: '입금자명',
			align: 'center',
			dataIndex: 'name',
		},
		{
			title: (
				<Tooltip
					title={'클릭시 변경가능합니다. 수정시 주의해주세요.'}
					style={{
						verticalAlign: 'middle',
					}}>
					<View
						style={{ flexDirection: 'row', alignItems: 'center' }}>
						<IconInfoCircle color="#1890ff" size={13} />
						비고
					</View>
				</Tooltip>
			),
			align: 'center',
			width: 200,
			dataIndex: 'bankaccount',
			render: (text, data) => {
				return <BankInput data={data} type={'D'} mutate={mutate} />
			},
		},
		{
			title: '관리메모',
			align: 'center',
			dataIndex: 'memo',
			render: (text, data) => (
				<MemoInput data={data} type={'D'} mutate={mutate} />
			),
		},
		{
			title: '관리',
			align: 'center',
			dataIndex: 'action',
			render: (text, data) => (
				<Space.Compact direction="horizontal">
					{data?.process != 2 ? (
						<>
							{data?.process != 3 && data?.process != 4 && (
								<ActionButton
									title={'검토'}
									process={3}
									mutate={mutate}
									id={data?.id}
								/>
							)}

							{data?.process != 2 && data?.process != 4 && (
								<ActionButton
									title={'승인'}
									process={9}
									price={data?.amount}
									type={data?.type}
									primary
									mutate={mutate}
									id={data?.id}
									data={data}
								/>
							)}
							{data?.process != 4 && (
								<ActionButton
									title={'거절'}
									process={4}
									mutate={mutate}
									id={data?.id}
								/>
							)}
						</>
					) : (
						<>
							{data?.process == 2 && !data?.confirm_amount && (
								<ActionButton
									title={'지급'}
									process={9}
									price={data?.amount}
									type={data?.type}
									primary
									mutate={mutate}
									id={data?.id}
									data={data}
								/>
							)}
						</>
					)}
				</Space.Compact>
			),
		},
	]
}
